export const president = [
  {
    id: 1,
    name: "Vihan Jayawardana",
    position: "OEP",
    phone: "+94 71 110 5769",
    email: "vihan.jayawardana@aiesec.net",
    color: "#fff",
  },
];

export const contacts = [
  {
    id: 1,
    name: "Indrachapa Ekanayake",
    position: "OEVP MXP",
    phone: "+94 76 554 3108",
    email: "indrachapa.ekanayake5@aiesec.net",
    color: "#fff",
  },
  {
    id: 2,
    name: "Fouzul Hassan",
    position: "OEVP F&L",
    phone: "+94 70 309 0599",
    email: "indrachapa.ekanayake5@aiesec.net",
    color: "#fff",
  },
  {
    id: 3,
    name: "Isuru Wickramage",
    position: "OEVP PD",
    phone: "+94 76 855 5573",
    email: "isuru.wickramage@aiesec.net",
    color: "#fff",
  },
  {
    id: 4,
    name: "Dinuka Nanayakkara",
    position: "OEVP EwA & Innovation",
    phone: "+94 76 421 2340",
    email: "dinuka.nanayakkara@aiesec.net",
    color: "#fff",
  },
  {
    id: 5,
    name: "Vishara Prabuddhi ",
    position: "OEVP DXP",
    phone: "+94 77 913 6035",
    email: "vishara.prabuddhi@aiesec.net",
    color: "#fff",
  },
  {
    id: 6,
    name: "Saad Rayyan",
    position: "OEVP oGT - PS",
    phone: "+94 72 258 6800",
    email: "saad.rayyan@aiesec.net",
    color: "#fff",
  },
  {
    id: 7,
    name: "Chethali Eliyapura",
    position: "OEVP oGX - B2C",
    phone: "+94 76 636 8079",
    email: "chethali.eliyapura4@aiesec.net",
    color: "#fff",
  },
  {
    id: 8,
    name: "Savith Rajakaruna",
    position: "OEVP MKT",
    phone: "+94 77 577 5237",
    email: "savith.rajakaruna@aiesec.net",
    color: "#fff",
  },
  {
    id: 9,
    name: "Shaveesha Rodrigo",
    position: "OEVP oGV - PS",
    phone: "+94 70 688 0286",
    email: "rodrigo.shaveesha@aiesec.net",
    color: "#fff",
  },
  {
    id: 10,
    name: "Induja Thilakarathne ",
    position: "OEVP iGV B2B & VD",
    phone: "+94 77 529 9676",
    email: "induja.thilakarathne@aiesec.net",
    color: "#fff",
  },
  {
    id: 11,
    name: "Anuththara Divyanjalie",
    position: "OEVP iGT IR & M",
    phone: "+94 77 861 9292",
    email: "anuththara.divyanjalie@aiesec.net",
    color: "#fff",
  },
  {
    id: 12,
    name: "Shamika Kumarasinghe",
    position: "OEVP iGT B2B & VD",
    phone: "+94 71 601 7450    ",
    email: "supun.shamika2@aiesec.net",
    color: "#fff",
  },
];

export const contact2 = [
  {
    id: 1,
    name: "Oshadhi Kulathilaka",
    position: "OEVP iGV IR & M",
    phone: "+94 71 463 1084",
    email: "oshadhi.kulathilaka@aiesec.net",
    color: "#fff",
  },
];
